<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import { ACNE_GRADE_OPTIONS } from '../types/acne-grade'

    export let data: Record<string, any>
</script>

<div class="acne-grade">
    {#each ACNE_GRADE_OPTIONS as option (option.key)}
        <div class="acne-row" class:selected={option.key === 'II'}>
            <span class="acne-label">
                {option.label}
                <span class="acne-tooltip-icon"><Fa icon={faCircleQuestion} /></span>
            </span>
            <span class="acne-inflammation">{option.inflammation}</span>
            <span class="acne-subtype">{option.subtype}</span>
        </div>
    {/each}
</div>

<style>
    .acne-grade {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .acne-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 10px 14px;
        border-radius: 8px;
        background: #f8f9fa;
    }
    .acne-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .acne-label {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .acne-row.selected .acne-label {
        color: #1f2937;
    }
    .acne-inflammation {
        flex: 1;
        min-width: 0;
        text-align: center;
        font-size: 0.85rem;
        color: #495057;
    }
    .acne-subtype {
        flex: 1;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .acne-row.selected .acne-inflammation,
    .acne-row.selected .acne-subtype {
        color: #1f2937;
    }
    .acne-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
    }
    .acne-row.selected .acne-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
